import './main.css';
import Flickity from 'flickity';
import asNavFor from 'flickity-as-nav-for';
import fullscreen from 'flickity-fullscreen';
import carousel from './src/js/carousel';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import {EqualHeights} from '@morev/equal-heights';
import menuDropdown from './src/js/menuDropdown';
import menuToggle from './src/js/menuToggle';
import playVideo from './src/js/playVideo';
import headerScroll from './src/js/headerScroll';
import widgetFlyout from './src/js/widgetFlyout';
import contactToggle from './src/js/contactToggle';

menuToggle();
menuDropdown();
playVideo();
headerScroll();
widgetFlyout();
contactToggle();

const equalHeights = new EqualHeights();
equalHeights.add([
    {
        selector: '.equal-height',
        options: {
            isEnabled: (window) => window.innerWidth >= 768,
        },
    },
]);
